<template>
  <PageLayout>
    <PageHeader :title="$t(`Common.title.homeTitle`)" :breadcrumb="[
      { title: $t(`Common.title.homeTitle`) },
      {
        title: `${this.$t(
          `Common.title.${this.$route.params?.type?.toString()}`
        )}`,
      },
    ]" />
    <div class="px-4">
      <m-card :title="`${this.$t(
        `Common.title.${this.$route.params?.type?.toString()}`
      )}`">
        <m-form ref="form">
          <m-input :maxLength="6" :rules="[
            { required: true, message: $t('Common.message.required') },
            { pattern: /[a-zA-Z0-9]{6}/, message: $t('apply.message.IDNumberTip') },
          ]" :label="$t('apply.title.IDNumber')" isFormItem layout="vertical" v-model="form.docNo"
            :placeholder="$t('apply.message.IDNumberTip')" />

          <div class="m-field__label mb-2">
            {{ $t("apply.title.liveNumber") }}
          </div>

          <div class="livenumber__field mb-2">
            <m-input class="hide_rules_title" :maxLength="6" layout="vertical" isFormItem v-model="form.autoNo"
              :placeholder="$t('apply.message.liveNumberTip')" :rules="[
                {
                  message: $t('Common.message.required'),
                  required: true,
                },
                {
                  pattern: /^\d+$/,
                  message: $t('apply.message.liveNumber'),
                },
              ]">
            </m-input>

            <div class="m-form-item-separator mx-2 mb-4">/</div>

            <m-input class="year_input hide_rules_title" layout="vertical" isFormItem :maxLength="4"
              v-model="form.illegalYear" :placeholder="$t('Common.message.validDateTip')" @input="handleInput" :rules="[
                {
                  message: $t('Common.message.required'),
                  required: true,
                },
              ]">
            </m-input>
          </div>
          <CaptchaText ref="captcha" v-model="form.captcha"></CaptchaText>
        </m-form>
      </m-card>
    </div>
    <template slot="actions">
      <m-button type="primary" ghost size="large" @click="onClose" class="mr-4">{{ this.$t('Common.action.backHome')
        }}</m-button>
      <m-button type="primary" size="large" @click="onNext">{{
        this.$t('Common.action.confirm')
        }}</m-button>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/PageLayout.vue';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';
import CaptchaText from '@/components/CaptchaText.vue';
import { ApplicationAPI } from 'govmo-common/src/api';

export default {
  components: {
    PageLayout,
    PageHeader,
    CaptchaText,
  },
  data() {
    return {
      form: {},
      searchData: {},
    };
  },

  methods: {
    handleInput(e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 4) {
        value = value.substr(0, 4);
      }
      this.form.illegalYear = value;
    },
    onClose() {
      this.$router.push({ name: 'home' });
    },
    async onNext() {
      if (!(await this.$refs.form.validateFields())) return;
      await this.queryData();
    },
    async queryData() {
      this.$showLoading();
      try {
        const { expire, signature } = await ApplicationAPI.getDetails(
          this.form
        );
        const { illegalYear, autoNo, docNo } = this.form;
        this.$router.push({
          name: 'searchResult',
          query: {
            illegalYear,
            autoNo,
            docNo,
            expire,
            signature,
          },
          params: {
            type: this.$route.params?.type ?? 'search',
          },
        });
      } catch (error) {
        this.$error(error);
        this.$refs.captcha.getCaptcha();
      } finally {
        this.$hideLoading();
      }
    },
  },
  created() { },
};
</script>
<style lang="scss" scoped>
.combination__field {
  width: 20%;
}

.combination__field_mobile {
  width: 30%;
}

::v-deep .m-form-item-wrapper .m-form-item-main {
  align-items: center;
}

@import '@/meta-variables.scss';

::v-deep .ant-card-head {
  min-height: 48px;
  margin-bottom: -1px;
  padding: 0 16px;
  color: #fff;
  font-size: 18px;
  background: var(--m-primary-color);
  border-radius: 10px 10px 0 0;
  zoom: 1;
}

.livenumber__field {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.m-form-item-separator {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
}

// 隱藏年份的必填content
::v-deep(.year_input.m-form-item-wrapper.require .label-wrapper::before) {
  content: '';
}

.m-field__label {
  position: relative;
  /* 确保伪元素定位正确 */
}

.m-field__label::before {
  content: "*";
  /* 添加 * 符号 */
  color: red;
  /* 设置为红色 */
  position: absolute;
  /* 定位到 div 左侧 */
  left: -10px;
  /* 调整 * 的位置，可根据需要调整 */
  top: 0;
  /* 垂直对齐 */
}

.hide_rules_title {
  ::v-deep(.m-form-item-main .label-wrapper) {
    display: none;
  }
}

// .hide_rules_title ::v-deep .m-form-item-main .label-wrapper {
//  display: none;
// }</style>
